import { render, staticRenderFns } from "./Examine.vue?vue&type=template&id=45ebd175&scoped=true&"
import script from "./Examine.vue?vue&type=script&lang=js&"
export * from "./Examine.vue?vue&type=script&lang=js&"
import style0 from "./Examine.vue?vue&type=style&index=0&id=45ebd175&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ebd175",
  null
  
)

export default component.exports